import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts, { ChartOptions, SeriesOptionsType, XAxisOptions } from 'highcharts';
import { defaultChartOptions, defaultTooltip, defaultXAxisFormat } from 'constants/chart-constants';
import { ChartProps, ChartSeries } from 'views/Analytics/AnalyticsMockService/Reporting/Report';

const BarsChart = (chartProps: ChartProps) => {
  const chartSeries: ChartSeries[] = chartProps.chartSeries;
  const barChartOptions: ChartOptions = {
    ...defaultChartOptions,
    type: 'column',
    zoomType: 'x',
  };

  // If we do not specify categories manually it is going to be date time series
  const xAxisConfig: XAxisOptions = {
    categories: chartProps.categories,
    type: chartProps.categories ? undefined : 'datetime',
    min: chartProps.min,
    max: chartProps.max,
    labels: {
      rotation: -45,
    },
    tickInterval: chartProps.tickInterval ? chartProps.tickInterval : undefined,
    dateTimeLabelFormats: defaultXAxisFormat,
  };

  const getOptions = () => {
    const options: Highcharts.Options = {
      chart: barChartOptions,
      title: {
        text: '',
      },
      xAxis: xAxisConfig,
      yAxis: {
        title: {
          text: '',
        },
        // Corrects maximum value on Y axis (https://www.highcharts.com/forum/viewtopic.php?t=10420)
        startOnTick: false,
        endOnTick: false,
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        floating: false,
        backgroundColor: 'white',
        borderWidth: 0,
        shadow: false,
        squareSymbol: true,
        symbolRadius: 0,
      },
      tooltip: chartProps.tooltip ? chartProps.tooltip : defaultTooltip,
      credits: {
        enabled: false,
      },
      plotOptions: {
        column: {
          stacking: 'normal',
        },
        series: {
          animation: {
            duration: 0,
          },
        },
      },
      drilldown: {
        animation: {
          duration: 0,
        },
      },
      series: chartSeries as Array<SeriesOptionsType>,
    };
    return options;
  };

  return (
    <div className="bars-chart">
      <HighchartsReact highcharts={Highcharts} options={getOptions()} />
    </div>
  );
};

export default BarsChart;
